module.exports = __webpack_public_path__ + "img/skin_menu_left.b293f2b0.png";